import { TFunction } from "i18next";
import { object, string } from "yup";

export const renameFolderSchema = (t: TFunction) =>
  object({
    title: string().required(t("folder.titleRequired")),
    url: string()
      .matches(
        /^[a-zA-Z0-9_-]+$/,
        "The URL should only contain letters, numbers, hyphens and underscores."
      )
      .required(t("folder.titleRequired")),
  });
